export default {
  'user_management.title': 'User Management',
  'user_management.headerTitle': 'Admin User List',
  'user_management.username': 'Username',
  'user_management.email': 'Email',
  'user_management.fullName': 'Full Name',
  'user_management.role': 'Role',
  'user_management.status': 'Status',
  'user_management.lastLogin': 'Last Login',
  'user_management.createdAt': 'Created At',
  'user_management.action': 'Actions',
  'user_management.edit': 'Edit',
  'user_management.delete': 'Delete',
  'user_management.create': 'Create Account',
  'user_management.createTitle': 'Create New Account',
  'user_management.editTitle': 'Edit Account',
  'user_management.cancel': 'Cancel',
  'user_management.password': 'Password',
  'user_management.password.new': 'New Password',
  'user_management.noRole': 'No role assigned',
  'user_management.placeholder.username': 'Enter username',
  'user_management.placeholder.email': 'Enter email',
  'user_management.placeholder.password': 'Enter password',
  'user_management.placeholder.password.new': 'Enter new password (leave blank if no change)',
  'user_management.placeholder.fullName': 'Enter full name (optional)',
  'user_management.placeholder.role': 'Select role',
  'user_management.placeholder.status': 'Select status',
  'user_management.rule.username.required': 'Please enter username!',
  'user_management.rule.username.min': 'Username must be at least 3 characters!',
  'user_management.rule.email.required': 'Please enter email!',
  'user_management.rule.email.invalid': 'Invalid email!',
  'user_management.rule.password.required': 'Please enter password!',
  'user_management.rule.password.min': 'Password must be at least 6 characters!',
  'user_management.rule.role.required': 'Please select at least one role!',
  'user_management.rule.status.required': 'Please select status!',
  'user_management.status.all': 'All',
  'user_management.status.active': 'Active',
  'user_management.status.inactive': 'Inactive',
  'user_management.status.suspended': 'Suspended',
  'user_management.confirmDelete': 'Confirm Delete',
  'user_management.confirmDeleteDesc': 'Are you sure you want to delete account "{username}"?',
  'user_management.permissionDenied': 'You do not have permission to perform this operation!',
  'user_management.roleConstraint.viewerOnly': 'You can only interact with Viewer accounts!',
  'user_management.createSuccess': 'Account created successfully!',
  'user_management.createFailed': 'Failed to create account!',
  'user_management.updateSuccess': 'Account updated successfully!',
  'user_management.updateFailed': 'Failed to update account!',
  'user_management.deleteSuccess': 'Account deleted successfully!',
  'user_management.deleteFailed': 'Failed to delete account!',
  'user_management.errorOccurred': 'An error occurred!',
};
